import OpenSavingsSuccess from 'features/accounts/savings/OpenSavingsSuccess/OpenSavingsSuccess';
import React from 'react';

export default function Page() {
  return <OpenSavingsSuccess />;
}
